import { useEffect } from 'react';

import { DEFAULT_LOCALE, isValidLocale } from '@/i18n/config';
import { useLocaleActions } from '@/i18n/LocaleStore';
import { useTranslation } from 'react-i18next';

export const LocaleStoreSyncProvider = () => {
  const { i18n } = useTranslation();

  const { setLocale } = useLocaleActions();

  // Sync i18n language with locale store
  useEffect(() => {
    setLocale(isValidLocale(i18n.language) ? i18n.language : DEFAULT_LOCALE);
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return null;
};
